import React from "react"
import {useTranslation} from "react-i18next"
import XIcon from "../../../resource/icon/x.svg"
import ShareButton from "./ShareButton"

interface XButtonProps {
  order: number
  shareUrl: string
  prefillTweetText?: string
  hashtags: string
  trackClick: () => void
}

export default function XButton({order, prefillTweetText, hashtags, shareUrl, trackClick}: XButtonProps) {
  const {t} = useTranslation()

  const shareToTwitter = () => {
    trackClick()

    let text = encodeURIComponent(prefillTweetText ?? "")
    let url = encodeURIComponent(shareUrl)

    let hashtagArray = hashtags.split('#').map(item => item.trim())
    hashtagArray.shift()
    let encodedHashtags = encodeURIComponent(hashtagArray.join())

    window.open(`https://twitter.com/intent/tweet?text=${text}&url=${url}&hashtags=${encodedHashtags}`)
  }

  return (
    <ShareButton
      order={order}
      onClick={shareToTwitter}
      style={{backgroundColor: "#000"}}
    >
      <img src={XIcon} alt="X Icon"/>
      <span style={{marginLeft: "8px"}}>{t("shareSheet.buttons.twitter")}</span>
    </ShareButton>
  )
}